//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IOpData, IReferenceType, IOpChangeState, IOpObject } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'
import { ObjectCustomString } from '../../models/util/object-custom-string'

import { OpDataList } from '../util/op-data-list'
import { OpDataType } from './op-data-type'
import { OpOperator } from './op-operator'
import { OpRouteDefData } from './op-route-def-data'
import { OpRouteType } from './op-route-type'
import { OpRouteStatus } from './op-route-status'


export class OpRouteDef implements IReferenceType, IOpObject, IOpChangeState {
    //Properties
    public idRouteDef: number
    public name: string
    public description: string
    public creationDate: Date
    public expirationDate: Date
    public deleteDate: Date
    public idRouteType: number
    public idRouteStatus: number
    public idOperator: number
    public adHoc: boolean
    //Properties end
    //NavigationProperties
    public routeType: OpRouteType
    public routeStatus: OpRouteStatus
    public operator: OpOperator
    //NavigationProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdRouteDef
    }
    public getReferenceKey(): number {
        return this.idRouteDef
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end
    //IOpObject implementation
    public get idObject(): any {
        return this.idRouteDef
    }
    public set idObject(idObject: any) {
        this.idRouteDef = idObject
    }

    public dataList: OpDataList<OpRouteDefData> = new OpDataList<OpRouteDefData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idRouteDef = opObj.ID_ROUTE_DEF
            this.name = opObj.NAME
            this.description = opObj.DESCRIPTION
            this.creationDate = opObj.CREATION_DATE
            this.expirationDate = opObj.EXPIRATION_DATE
            this.deleteDate = opObj.DELETE_DATE
            this.idRouteType = opObj.ID_ROUTE_TYPE
            this.idRouteStatus = opObj.ID_ROUTE_STATUS
            this.idOperator = opObj.ID_OPERATOR
            this.adHoc = opObj.AD_HOC

            if (opObj._RouteType)
                this.routeType = new OpRouteType(opObj._RouteType)
            if (opObj._RouteStatus)
                this.routeStatus = new OpRouteStatus(opObj._RouteStatus)
            if (opObj._Operator)
                this.operator = new OpOperator(opObj._Operator)

            if (opObj.DataList)
                this.dataList.push(...opObj.DataList.map(data => new OpRouteDefData(data)))
            else
                this.dataList = new OpDataList<OpRouteDefData>()

            this.dynamicValues = opObj.dynamicValues

            this.opState = opObj.OpState
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ROUTE_DEF: this.idRouteDef,
            NAME: this.name,
            DESCRIPTION: this.description,
            CREATION_DATE: this.creationDate,
            EXPIRATION_DATE: this.expirationDate,
            DELETE_DATE: this.deleteDate,
            ID_ROUTE_TYPE: this.idRouteType,
            ID_ROUTE_STATUS: this.idRouteStatus,
            ID_OPERATOR: this.idOperator,
            AD_HOC: this.adHoc,

            DataList: this.dataList ? this.dataList.ToJSON() : null,
            OpState: this.opState
        }
    }

    public toString() {
        var customFormatString = ObjectCustomString.getCustomStringFormat(this)
        if (!customFormatString) {
            return this.name
        }
        else {
            return ObjectCustomString.getObjectCustomString(customFormatString, this)
        }
    }
    //IOpObject implementation end

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpRouteDef[]): JQueryPromise<OpRouteDef[]> {
        var defered = $.Deferred<OpRouteDef[]>()

        if (dataProvider && list && list.length > 0) {
            var idDataType: number[] = CommonHelper.getIdDataTypesFromObjectList<OpRouteDef>(list)
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType, Enums.ReferenceType.IdRouteType, Enums.ReferenceType.IdRouteStatus]).then(dict => {
                var dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                var routeTypeDict: Dictionary<OpRouteType> = new Dictionary<OpRouteType>(null)
                var routeStatusDict: Dictionary<OpRouteStatus> = new Dictionary<OpRouteStatus>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }
                if (dict.containsKey(Enums.ReferenceType.IdRouteType)) {
                    routeTypeDict = <Dictionary<OpRouteType>>dict.tryGetValue(Enums.ReferenceType.IdRouteType)
                }
                if (dict.containsKey(Enums.ReferenceType.IdRouteStatus)) {
                    routeStatusDict = <Dictionary<OpRouteStatus>>dict.tryGetValue(Enums.ReferenceType.IdRouteStatus)
                }

                list.forEach(item => {
                    if (item.dataList) {
                        item.dataList
                            .toArray()
                            .forEach((data: OpRouteDefData) => {
                                data.dataType = dataTypeDict.tryGetValue(data.idDataType)
                            })
                    }
                    item.routeStatus = routeStatusDict.tryGetValue(item.idRouteStatus)
                    item.routeType = routeTypeDict.tryGetValue(item.idRouteType)
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }

    public static fromIOpObject(object: IOpObject): OpRouteDef {
        var newObject: OpRouteDef = new OpRouteDef(null)
        newObject.idRouteDef = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpRouteDefData.fromIOpData(data)))
        return newObject
    }
}